module.exports = __webpack_public_path__ + "img/testimonials-icon-green.673aebd2.svg";